import { makeStyles } from 'tss-react/mui';
import { Palette, Tokens } from '@jda/lui-common-component-library-mui5';

export default makeStyles()(theme => ({
  modalTextBox: {
    paddingRight: Tokens.spacing['$sp-2-5'],
  },
  modalFormContent: {
    display: 'flex',
    alignItems: 'center'
  },
  dropDownText: {
    '& #dropdown-inputlabel-IDPDropdown': {
      fontSize: Tokens.spacing['$sp-4-5'],
    },
    marginBottom: Tokens.spacing['$sp-5'],
  },
  roleMappingAlert: {
    marginBottom: Tokens.spacing['$sp-4'],
  },
  alertMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: Tokens.spacing['$sp-4'],
    padding: Tokens.spacing['$sp-4'],
    borderRadius: Tokens.spacing['$sp-1-25'],
    color: theme.palette.text.primary,
    backgroundColor: Palette.colors.byBlue['50'],
    border: `1px solid ${theme.palette.primary.main}`,
    fontSize: Tokens.spacing['$sp-3-5'],
  },
  bellIcon: {
    marginRight: 10,
    color: theme.palette.primary.main,
  },
  listbox: {
    paddingTop: Tokens.spacing['$sp-2'],
    '& li:first-child': {
      borderTop: `1px solid ${theme.palette.background.paper}`
    },
    '& li:nth-child(2n)': {
      cursor: 'pointer'
    }
  },
  groupBy: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(10),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  searchIcon: {
    padding: 0,
    color: theme.palette.text.secondary,
    cursor: 'initial'
  },
  alertText: {
    // color: theme.palette.,
  },
  optionItem: {
      display: 'block',
      height: '100%!important',
      paddingTop: Tokens.spacing['$sp-3'],
      paddingBottom: Tokens.spacing['$sp-3'],
      paddingLeft: Tokens.spacing['$sp-4'],
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    optionItemName: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: '20px'
    },
    optionItemDescription: {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.text.secondary,
      lineHeight: '16px'
    },
}));
